import { Component, ViewEncapsulation } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-position-day-wks-actions',
  templateUrl: './position-day-wks-actions.component.html',
  encapsulation: ViewEncapsulation.None
})
export class PositionDayWksActionsComponent implements ICellEditorAngularComp {
  agParam: any;

  resetPosition(event) {
    event.stopPropagation();
    if (this.canReset()) {
      this.agParam.context.componentParent.verifyPositionToReset(this.agParam.data);
    }
  }

  canReset() {
    return this.agParam.context.componentParent.canReset(this.agParam.data);
  }

  agInit(params): void {
    this.agParam = params;
  }

  getValue() {
    throw new Error("Method not implemented.");
  }
  isPopup?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelBeforeStart?(): boolean {
    throw new Error("Method not implemented.");
  }
  isCancelAfterEnd?(): boolean {
    throw new Error("Method not implemented.");
  }
  focusIn?(): void {
    throw new Error("Method not implemented.");
  }
  focusOut?(): void {
    throw new Error("Method not implemented.");
  }
  afterGuiAttached?(params?): void {
    throw new Error("Method not implemented.");
  }
}
